import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { DualListComponent } from 'angular-dual-listbox';
import { Router, ActivatedRoute } from '@angular/router';
import { PositionFacade } from '../../../common/facade/PositionFacade';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { Position } from '../../../common/model/Position';
import { CatalogDetFacade } from '../../../common/facade/CatalogDetFacade';
import { SecurityFacade } from '../../../common/facade/SecurityFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { PositionParamsDtos } from '../../../common/model/dto/PositionParamsDtos';
import { PositionStoreFacade } from '../../../common/facade/PositionStoreFacade';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { Tenant } from '../../../common/model/Tenant';
import { Organization } from '../../../common/model/Organization';
import { ComboMultiSelectComponent } from '../../../containers/combo-multi-select/combo-multi-select.component';


@Component({
  selector: 'app-organization-chart-detail',
  templateUrl: './organization-chart-detail.component.html',
  styleUrls: ['./organization-chart-detail.component.css']
})
export class OrganizationChartDetailComponent implements OnInit {
    res = res;
    lblEmployeeName = res.EmployeeName;
    lblCleanData = res.CleanData;
    lblPosition = res.Position;
    lblCountry = res.Country;
    lblSelectAnOption = res.SelectAnOption;
    lblCancel = res.Cancel;
    lblAllStores = res.AllStores;
    isSpanish = true;
    language = 0
    loading = false;
    messageLoader = '';
    title: string;
    buttonTittle: string;
    _idPositionSelected = 0;
    _positionSelected: Position;
    alerts = [];
    // Positions
    positionIdSeleccionado = -1;
    positions: Array<Position>;
    // puesto
    puestoIdSeleccionado = -1;
    puestos: Array<any>;
    // Países
    selectedCountryId = -1;
    countries = [];
    // ModelFormulario
    mName = '';
    mEmail = '';
    mNombreEmpleado = '';
    // Lista Tiendas
    keepSorted = false;
    key = 'storeId';
    display = 'storeName';
    filter = false;
    source: Array<any>;
    confirmed: Array<any>;
    format: any = DualListComponent.DEFAULT_FORMAT;
    allStores = false;
    private stores: Array<any>;
    private storesAsignated: Array<any>;
    // permissions
    // tslint:disable-next-line: member-ordering
    permissionsList: any[] = [];

    public tenantList: Tenant[] = [];
    selectedTenant: any[] = [];
    selectedTenantName: any[] = [];
  
    public organizationList: Organization[] = [];
    public organizationListTemp: any[];
    tenantId: Number = -1;
    public availableOrganizations: Organization[] = [];
    public availableTenants: Tenant[] = [];
    
    public selectedOrganization: any[];
    public changeOrganization = false;

    public organizatioAsigned: any[];
    public tenatAsigned: any[];
    public organizatioAsignedName: any[];
    public tenatAsignedName: any[];

    // buttons
    save = false;
    aux = () => { };

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

    @ViewChild(ComboMultiSelectComponent) cmbMultiSelect;
    strselectedTenant: string;
    strSelectedOrganization: string;

    
  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private positionService: PositionFacade,
    private catalogDetService: CatalogDetFacade,
    private securityService: SecurityFacade,
    private storeService: StoreFacade,
    private positionStoreService: PositionStoreFacade,
    public strings: Strings
  ) { }  

  ngOnInit() {
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1
    }

    // validar permisos
    this.validatePermissions();
    this.format.add = this.strings.GetText(res.Add);
    this.format.remove = this.strings.GetText(res.Delete);
    this.format.all = this.strings.GetText(res.AllO);
    this.format.none = this.strings.GetText(res.None);
    this._idPositionSelected = +this.route.snapshot.paramMap.get('id');
    if (this._idPositionSelected === 0) {
      this.title = this.strings.GetText(res.AddEmployee);
      this.buttonTittle = this.strings.GetText(res.SaveEmployee);
    } else {
      this.title = this.strings.GetText(res.EditEmployee);
      this.buttonTittle = this.strings.GetText(res.SaveChanges);
    }
    this.obtenerPositions();
    this.obtenerPuestos();
    this.obtenerTiendas();
    this.getCountries();
    this.tenantList = this.strings.getAvailableTenants();
    this.availableOrganizations = this.strings.getAvailableOrganizations();
    }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions');
    // validar si cuenta con el permiso para añadir un nuevo checklist
    this.permissionsList.forEach(element => {
      if (element.name === Permissions.GeneralAccess || element.name === Permissions.ConfigPositionCreate) {
        this.save = true;
      }
    });
  }

  mapPosition() {
    this._positionSelected = this.positions.find(x => x.positionId === this._idPositionSelected);
    if (this._positionSelected) {
      this.mName = this._positionSelected.name;
      this.puestoIdSeleccionado = this._positionSelected.catDetJobId;
      this.positionIdSeleccionado = this._positionSelected.subordinatePositionId;
      this.mNombreEmpleado = this._positionSelected.employeeName;
      this.mEmail = this._positionSelected.employeeEmail;
      this.allStores = this._positionSelected.allStores;
        this.selectedCountryId = this._positionSelected.catDetCountryId;
        //this.strSelectedOrganization = this._positionSelected.organizationId;
        this.changeOrganization = true;
        var strorgasig = this._positionSelected.organizationId;
        var listtenant = this.availableOrganizations.filter(org => strorgasig.includes(org.organizationId));
        var strlisttenat = listtenant.map(x => x.tenantId).join(',');
        var temorga = this.availableOrganizations.filter(org => strorgasig.includes(org.organizationId));
        var temtenant = this.tenantList.filter(tnt => strlisttenat.includes(tnt.tenantId.toString()));
        this.organizatioAsignedName = [...new Set(temorga.map(y => y.name))];
        this.tenatAsignedName = [...new Set(temtenant.map(y => y.name))];
        this.selectedTenant = temorga;
        this.selectedOrganization = temorga;
        this.ReloadSourse();
    }
  }

  obtenerPositions() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this.positionService.GetPosition().subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.positions = response.data;
          if (this._idPositionSelected !== 0) {
            this.mapPosition();
          }
        } else {
          this.muestraError('<strong> ' + this.strings.GetText(res.PositionsWereNotObtained) + ', ' + response.message + ' </strong>');
          return;
        }
      },
      error => {
        this.loading = false;
        this.muestraError('<strong>' + error + '</strong>');
      }
    );
  }

  obtenerPuestos() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this.catalogDetService.Get(21, this.language).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.puestos = response.data;
        } else {
          this.muestraError('<strong> ' + this.strings.GetText(res.PositionsWereNotObtained) + ', ' + response.message + ' </strong>');
          return;
        }
      },
      error => {
        this.loading = false;
        this.muestraError('<strong>' + error + '</strong>');
      }
    );
  }

  obtenerTiendas() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this.storeService.GetAll().subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.stores = response.data;
          this.asignarTiendas();
        } else {
          this.muestraError('<strong> ' + this.strings.GetText(res.ThereWasAnErrorGettingTheStores) + ', ' + response.message + ' </strong>');
          return;
        }
      },
      error => {
        this.loading = false;
        this.muestraError('<strong>' + error + '</strong>');
      }
    );
  }

  getCountries() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.ObtainingListOfCountries);
    this.catalogDetService.Get(44, this.language).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.countries = response.data;
        } else {
          this.muestraError('<strong> ' + this.strings.GetText(res.CountriesWereNotObtained) + ', ' + response.message + ' </strong>');
          return;
        }
      },
      error => {
        this.loading = false;
        this.muestraError('<strong>' + error + '</strong>');
      }
    );
  }

  asignarTiendas() {
    if (this._idPositionSelected === 0) {
      //this.source = this.stores;
      this.confirmed = new Array<any>();
    } else {
      this.source = new Array<any>();
      this.confirmed = new Array<any>();
      this.obtenerTiendasAsignadas();
    }
  }

  obtenerTiendasAsignadas() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this.positionStoreService.GetPositionStoreByPositionId(this._idPositionSelected).subscribe(
      response => {
        this.selectedTenantName = this.tenantList.map(x => x.name);
        this.loading = false;
            if (response.completed) {
                
                this.storesAsignated = response.data;
                this.filtrarTiendasAsignadas();
                this.organizatioAsigned = [...new Set(response.data.map(x => x.organizationId))];
                if (this.organizatioAsigned.length > 0) {
                //   this.changeOrganization = true;
                //    var strorgasig = this.organizatioAsigned.map(x => x).join(',');
                //    var listtenant = this.availableOrganizations.filter(org => strorgasig.includes(org.organizationId));
                //    var strlisttenat = listtenant.map(x => x.tenantId).join(',');
                //    var temorga = this.availableOrganizations.filter(org => strorgasig.includes(org.organizationId));
                //    var temtenant = this.tenantList.filter(tnt => strlisttenat.includes(tnt.tenantId.toString()));
                //    this.organizatioAsignedName = [...new Set(temorga.map(y => y.name))];
                //    this.tenatAsignedName = [...new Set(temtenant.map(y => y.name))];
                //    this.selectedTenant = temorga;
                //    //this.strselectedTenant = strlisttenat;
                //    //this.loadOrganization();
                //    this.selectedOrganization = temorga;
                    this.ReloadSourse();
                }
          
        } else {
          this.muestraError('<strong> ' + this.strings.GetText(res.ThereWasAnErrorGettingTheStores) + ', ' + response.message + ' </strong>');
          return;
        }
      },
      error => {
        this.loading = false;
        this.muestraError('<strong>' + error + '</strong>');
      }
    );
  }

  filtrarTiendasAsignadas() {
    this.stores.forEach(
      item => {
        if (this.storesAsignated.find(x => x.storeId === item.storeId)) {
          this.confirmed.push(item);
        } else {
          this.source.push(item);
        }
      }
    );
    //this.source = this.stores;
  }

  validateEmail(callback: () => void) {
    if (this.mEmail.length > 0) {
      this.loading = true;
      this.messageLoader = this.strings.GetText(res.Validating);
      this.securityService.ValidateEmail(this.mEmail, this.language).subscribe(
        response => {
          this.loading = false;
          if (response.completed) {
            this.mNombreEmpleado = response.data.name;
            callback();
          } else {
            this.muestraError('<strong> ' + this.strings.GetText(res.InvalidEmail) + ' </strong>');
            return;
          }
        },
        error => {
          this.loading = false;
          this.muestraError('<strong>' + error + '<strong>');
          return;
        }
      );
    } else {
      this.muestraError('<strong> ' + this.strings.GetText(res.MissingAddEmail) + ' <strong>');
    }
  }

  gotoOrganizationChart() {
    this.router.navigate(['/config/organization-chart']);
  }

  addPosition() {
    if (this.mNombreEmpleado.length <= 0 && this.mEmail.length > 0) {
      this.validateEmail(
        () => {
          this.addPosition();
        }
      );
    } else {
      if (this.validateProperties()) {
        this.strSelectedOrganization = this.selectedOrganization.map(x => x.organizationId).join(',');
        if (this._idPositionSelected === 0) {
          this.guardarNuevaPlaza();
        } else {
          this.actualizaPlaza();
        }
      } else {
        this.muestraError('<strong> ' + this.strings.GetText(res.SomeFieldsAreMissing) + ' <strong>');
      }
    }
  }

  guardarNuevaPlaza() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.SavingInformation);

    const req = new PositionParamsDtos();
    req.CatDetJobId = this.puestoIdSeleccionado;
    req.EmployeeName = this.mNombreEmpleado;
    req.Name = this.mName;
    req.EmployeeEmail = this.mEmail;
    req.AllStores = this.allStores;
    req.SubordinatePositionId = this.positionIdSeleccionado;
    req.CatDetCountryId = this.selectedCountryId;
    req.OrganizationId = this.strSelectedOrganization;

    this.positionService.PostPosition(req).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.addPositionStore(response.data);
        } else {
          this.muestraError('<strong> ' + this.strings.GetText(res.ThePlaceWasNotSaved) + ', ' + response.message + ' </strong>');
          return;
        }
      },
      error => {
        this.loading = false;
        this.muestraError('<strong>' + error + '</strong>');
      }
    );
  }

  actualizaPlaza() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.SavingInformation);
    const req = new PositionParamsDtos();
    req.CatDetJobId = this.puestoIdSeleccionado;
    req.EmployeeName = this.mNombreEmpleado;
    req.Name = this.mName;
    req.EmployeeEmail = this.mEmail;
    req.AllStores = this.allStores;
    req.SubordinatePositionId = this.positionIdSeleccionado;
    req.CatDetCountryId = this.selectedCountryId;
    req.OrganizationId = this.strSelectedOrganization;
      
    this.positionService.PutPosition(req, this._idPositionSelected).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.updatePositionStore();
        } else {
          this.muestraError('<strong> ' + this.strings.GetText(res.ThePlaceWasNotUpdated) + ', ' + response.message + ' </strong>');
          return;
        }
      },
      error => {
        this.loading = false;
        this.muestraError('<strong>' + error + '<strong>');
      }
    );
  }

  addPositionStore(positionID: number) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.SavingInformation);
    this.confirmed.forEach(x => {
      this.positionStoreService.PostPosition({
        PositionId: positionID,
        StoreId: x.storeId
      }).subscribe();
    });

    setTimeout(() => {
      this.loading = false;
      this.gotoOrganizationChart();
    }, 5000);
  }

  updatePositionStore() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.SavingInformation);

    this.positionStoreService.DeletePositionList(this.storesAsignated)
        .subscribe(Response2 => {
            if (Response2.completed ) {
                this.confirmed.forEach(x => {
                    setTimeout(() => {
                        this.positionStoreService.PostPosition({
                            PositionId: this._idPositionSelected,
                            StoreId: x.storeId
                        }).subscribe();
                    }, 500);
                        
                });
            }
        });
   
    setTimeout(() => {
      this.loading = false;
      this.gotoOrganizationChart();
    }, 5000);
  }

  validateProperties() {
    if (this.puestoIdSeleccionado == -1 || this.selectedCountryId == -1) {
      return false;
    }
    return true;
  }

  onPuestoChange() {
    // console.log(this.puestoIdSeleccionado);
  }

  onPositionChange() {
    // console.log(this.positionIdSeleccionado);
  }

  // añadir alert
    muestraError(message: String): void {
    this.alerts = [];
    this.alerts.push({
      type: 'danger',
        msg: message
    });
  }

  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }

  lpad(value, padding) {
    const zeroes = new Array(padding + 1).join('0');
    return (zeroes + value).slice(-padding);
  }
   
    onChangeTenant(selectedTenant: any[]) {
        this.changeOrganization = false;
        
        this.organizationListTemp = [];
        this.selectedTenant = selectedTenant;
        this.strselectedTenant = this.selectedTenant.map(t => t.tenantId).join(',');
        this.loadOrganization();

        setTimeout(() => {
            this.changeOrganization = true;
            this.organizatioAsignedName = [];
            if (this.strselectedTenant.length <= 0) {
                this.changeOrganization = false;
            }
            this.organizationList = this.organizationListTemp;
        }, 100);

    }

    onChangeOrganization(selectedOrganization: any[]) {
        this.selectedOrganization = selectedOrganization;
        this.ReloadSourse();
    }
    loadOrganization() {
        if(this.selectedTenant.length > 0) {
            this.organizationListTemp = this.availableOrganizations.filter(org => this.strselectedTenant.includes(org.tenantId.toString()));
        }
        else {
            this.organizationListTemp = [];
            this.source = [];
            this.changeOrganization = false;
        }
    }
    ReloadSourse() {
        this.source = [];
        
        this.strSelectedOrganization = this.selectedOrganization.map(x => x.organizationId).join(',');
        if (this.selectedOrganization.length > 0) {
            this.source = this.stores.filter(st => this.strSelectedOrganization.includes(st.organizationId));

        } else {
            this.source = this.stores;
        }
    }
}
